// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue'
import App from './App'
import VueResource from 'vue-resource'
import vant from 'vant';
import * as trace from './lib/Utils/trace.js'
import router from './router'
import toast from './components/toast'
import tracker from './utils/tracker'
import Utils from './lib/Utils/index'
import $ from './lib/jquery-1.9.1.min.js'
import ajaxfileupload from './lib/ajaxfileupload.js'
import safe from './scripts/safe.js'
import zepto from "./mobiscroll/js/mobiscroll.zepto.js"
import core from "./mobiscroll/js/mobiscroll.core.js"
import frame from "./mobiscroll/js/mobiscroll.frame.js"
import scroller from "./mobiscroll/js/mobiscroll.scroller.js"
import listbase from "./mobiscroll/js/mobiscroll.listbase.js"
import treelist from "./mobiscroll/js/mobiscroll.treelist.js"
import holo from "./mobiscroll/js/mobiscroll.frame.android-holo.js"
import light from "./mobiscroll/js/mobiscroll.android-holo-light.js"
import i18n from "./mobiscroll/js/mobiscroll.i18n.zh.js"
import wkb from '@wifikey/wkb';
import 'vant/lib/index.css';

Vue.use(vant);
Vue.use(VueResource);
Vue.config.productionTip = false
Vue.prototype.$trace = trace
Vue.prototype.$toast = toast
Vue.prototype.$wkb = wkb;

router.afterEach(() => {
  window.scrollTo(0, 0);
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js